import type { IComponentController } from '@wix/editor-elements-types/thunderbolt';

const mapActionsToProps: IComponentController = ({ reportBi }) => ({
  reportBi,
});

export default mapActionsToProps;
